import React from 'react';
import Appearance from 'styles/Appearance.js';
import config from 'files/api.js';
import PageLayout from 'views/PageLayout.js';

const ReturnsPage = () => {

    const sections = [
        { h: '14-day returns', p: 'If your system isn’t the right fit, you can return it within 14 days of delivery for a refund.' },
        { h: 'Condition', p: 'Items should be returned in their original condition and packaging, with all included accessories.' },
        { h: 'How to start a return', p: `Contact our support team at ${config.store.email} with your order number, and we’ll send you return instructions.` },
        { h: 'Refunds', p: 'Once we receive and inspect your return, your refund is issued to the original payment method. Please allow a few business days for it to appear on your statement.' },
        { h: 'Manufacturer warranty', p: 'Beyond the return window, every device is backed by our manufacturer warranty against defects. Reach out any time with a warranty question.' },
        { h: 'Questions', p: `We’re here to help — contact us at ${config.store.email} or ${config.store.phone}.` },
    ];

    return (
        <PageLayout
            eyebrow={'Returns'}
            title={'Return policy'}
            subtitle={'Try it risk-free. If it isn’t right for your home, sending it back is easy.'}>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
                {sections.map((s, index) => (
                    <div key={index} style={{ borderTop: index === 0 ? 'none' : `1px solid ${Appearance.colors.border()}`, paddingTop: index === 0 ? 0 : 28 }}>
                        <h2 style={{ ...Appearance.textStyles.subHeading({ fontSize: 19 }), marginBottom: 10 }}>{s.h}</h2>
                        <p style={Appearance.textStyles.body({ fontSize: 16, lineHeight: 1.6 })}>{s.p}</p>
                    </div>
                ))}
            </div>
        </PageLayout>
    );
};

export default ReturnsPage;
